var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0004 21.6004C17.3023 21.6004 21.6004 17.3023 21.6004 12.0004C21.6004 6.69846 17.3023 2.40039 12.0004 2.40039C6.69846 2.40039 2.40039 6.69846 2.40039 12.0004C2.40039 17.3023 6.69846 21.6004 12.0004 21.6004Z",
    stroke: "#DC3232",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0004 21.6004C17.3023 21.6004 21.6004 17.3023 21.6004 12.0004C21.6004 6.69846 17.3023 2.40039 12.0004 2.40039C6.69846 2.40039 2.40039 6.69846 2.40039 12.0004C2.40039 17.3023 6.69846 21.6004 12.0004 21.6004Z",
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7148 9.28516L9.28426 14.7157",
    stroke: "#DC3232",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7148 9.28516L9.28426 14.7157",
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28516 9.28516L14.7157 14.7157",
    stroke: "#DC3232",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28516 9.28516L14.7157 14.7157",
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelHover);
export default __webpack_public_path__ + "static/media/cancel-hover.d8fc37bff636a5ed4fd428f50dcaec83.svg";
export { ForwardRef as ReactComponent };